module.exports = __webpack_public_path__ + "static/media/calculator.1dc042e3.svg";